import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import { useEffect } from "react";

function InvalidateSizeOnMount() {
  const map = useMap();

  useEffect(() => {
    // When shown inside a modal, Leaflet often needs a size refresh.
    // rAF ensures the modal has painted before invalidation.
    requestAnimationFrame(() => map.invalidateSize());
  }, [map]);

  return null;
}

export default function PointMap({ lat, lng, zoom = 13, height = "100%" }) {
  // guard: avoid crashing Leaflet when coords are missing
  if (lat == null || lng == null) return null;

  return (
    <MapContainer
      center={[lat, lng]}
      zoom={zoom}
      style={{ width: "100%", height }}
      scrollWheelZoom={false}
    >
      <InvalidateSizeOnMount />
      <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={[lat, lng]} />
    </MapContainer>
  );
}
